import { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useColorContext } from '../../context/ColorContext'
import axios from 'axios'
import classNames from 'classnames'
import './LookingForColors.scss'

const URL = process.env.REACT_APP_API_URL

export default function LookingForColors() {
	const { colors, setColors, isLoading, setIsLoading } = useColorContext()
	const { keyword } = useParams()

	const [itemHeights, setItemHeights] = useState([])
	const [copiedIndex, setCopiedIndex] = useState(null)
	const [hasError, setHasError] = useState(false)

	const getColumnCount = () => {
		const width = window.innerWidth
		if (width >= 1010) return 4
		if (width >= 770) return 3
		if (width >= 520) return 2
		return 1
	}
	const [columnCount, setColumnCount] = useState(getColumnCount())

	useEffect(() => {
		const handleResize = () => setColumnCount(getColumnCount())
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	useEffect(() => {
		const fetchColors = async () => {
			try {
				const randomHeights = Array.from({ length: 20 }, () => {
					const min = 200
					const max = 320
					return `${(Math.random() * (max - min) + min).toFixed(2)}px`
				})
				setItemHeights(randomHeights)
				setIsLoading(true)
				setHasError(false)

				// Показуємо заглушку
				setColors(Array.from({ length: 20 }, () => '#778a99'))

				const data = keyword.toLowerCase()
				const res = await axios.get(`${URL}/colors`, {
					params: { keyword: data },
				})

				setColors(res.data.colors)
			} catch (err) {
				console.error('Помилка запиту кольорів:', err)
				setHasError(true)
			} finally {
				setIsLoading(false)
			}
		}

		if (keyword) {
			fetchColors()
		}
	}, [keyword])

	const columns = useMemo(() => {
		const cols = Array.from({ length: columnCount }, () => [])
		colors.forEach((color, i) => {
			const colIndex = i % columnCount
			cols[colIndex].push({
				color,
				height: itemHeights[i],
				isLight: isLightColor(color),
			})
		})
		return cols
	}, [colors, itemHeights, columnCount])

	const handleCopy = (color, globalIndex) => {
		try {
			navigator.clipboard.writeText(color)
			setCopiedIndex(globalIndex)
			setTimeout(() => setCopiedIndex(null), 1000)
		} catch (err) {
			console.error('Не вдалося скопіювати:', err)
		}
	}

	return (
		<div className='looking'>
			<h2 className='keyword'>{keyword}</h2>

			<ul className='looking-list'>
				{columns.map((col, colIndex) => (
					<li className='looking-column' key={colIndex}>
						{col.map((item, j) => {
							const globalIndex = colIndex * columnCount + j

							return (
								<div
									key={j}
									className={classNames('looking-item', {
										placeholder: isLoading,
										'final-error': hasError && !isLoading,
									})}
									style={{
										backgroundColor: item.color,
										height: item.height,
										color: isLoading ? '#ccc' : item.isLight ? '#000' : '#fff',
									}}
								>
									<p
										onClick={() =>
											!isLoading && handleCopy(item.color, globalIndex)
										}
									>
										{!isLoading && !hasError && item.color}
									</p>

									{copiedIndex === globalIndex && (
										<span
											className='copied-message'
											style={{
												color: item.isLight ? '#000' : '#fff',
											}}
										>
											HEX скопійовано!
										</span>
									)}

									{hasError && !isLoading && (
										<span className='error-message'>Збій генерації!</span>
									)}
								</div>
							)
						})}
					</li>
				))}
			</ul>
		</div>
	)
}

function isLightColor(hex) {
	const r = parseInt(hex.substr(1, 2), 16)
	const g = parseInt(hex.substr(3, 2), 16)
	const b = parseInt(hex.substr(5, 2), 16)
	const brightness = 0.299 * r + 0.587 * g + 0.114 * b
	return brightness > 200 // зміщено в бік світлого було 128 s 150
}
